import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';

export default class ChatReportUserNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    return '#';
  }

  content() {
    let text = '<div><p>' + app.translator.trans('dl-wiki.forum.warn.chatReportUser_textOne')+ '</p><p>' + app.translator.trans('dl-wiki.forum.warn.chatReportUser_textTwo')+ '</p></div>';
    return text;

  }
}
